import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { label: 'Solutions', id: 'solutions' },
    { label: 'Brands', id: 'brands' },
    { label: 'About', id: 'social-proof' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className={`h-24 flex items-center px-3 py-2 transition-all duration-300 ${
              isScrolled 
                ? '' 
                : 'bg-white/95 backdrop-blur-sm rounded-lg shadow-md'
            }`}>
              <img 
                src="/logos/atoz-header.png" 
                alt="A To Z Infraspares Pvt Ltd"
                className="h-20 w-auto object-contain"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`font-medium transition-colors hover:text-green-500 ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:+919415456760" className={`flex items-center space-x-2 transition-colors ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>
              <Phone className="w-4 h-4" />
              <span className="font-medium">+91 94154 56760</span>
            </a>
            <Button 
              onClick={() => scrollToSection('quote-form')}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 shadow-lg hover:shadow-xl transition-all"
            >
              Get Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 bg-white rounded-b-2xl shadow-xl">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-gray-700 hover:text-green-500 font-medium text-left px-4 transition-colors"
                >
                  {link.label}
                </button>
              ))}
              <div className="px-4 pt-4 border-t">
                <a href="tel:+919415456760" className="flex items-center space-x-2 text-gray-700 mb-4">
                  <Phone className="w-4 h-4" />
                  <span>+91 94154 56760</span>
                </a>
                <Button 
                  onClick={() => scrollToSection('quote-form')}
                  className="w-full bg-green-600 hover:bg-green-700 text-white"
                >
                  Get Quote
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
